export class AdvanceError extends Error {
  title?: string;
  code?: string;
  url?: string;
  extraIinfo?: any;

  constructor(
    message?: string | Error,
    title?: string,
    code?: string,
    url?: string,
    extraIinfo?: any
  ) {
    super(message instanceof Error ? message.toString() : message);
    this.stack =
      message instanceof Error ? message.stack ?? this.stack : this.stack;
    this.name = title ?? this.name;
    this.title = title;
    this.code = code;
    this.url = url;
    this.extraIinfo = JSON.stringify(extraIinfo);
  }

  toString(): string {
    const infoObj = {
      name: this.name ?? '',
      message: this.message ?? '',
      title: this.title ?? '',
      code: this.code ?? '',
      url: this.url ?? '',
      stack: this.stack ?? '',
      extraInfo: this.extraIinfo ?? '',
    };
    return JSON.stringify(infoObj);
  }
}
